import { HookSystem } from "./lib/HookSystem.js";
const createPluginHookSystem = () => {
  return new HookSystem();
};
export {
  createPluginHookSystem
};
//# sourceMappingURL=createPluginHookSystem.js.map
